import { Actions, Badge, NameCell } from "@";
import type { ColumnDef } from "@tanstack/react-table";
import type { Driver } from "../types";
import {
  type DriverPermissionKey,
  driverPermissionsLabels,
} from "../lib/permissions";

interface CreateTableColumnsArgs {
  canEdit: boolean;
  onEdit: (driver: Driver) => void;
  onDelete: (id: number) => void | Promise<void>;
}

const PermissionsBadges = ({ driver }: { driver: Driver }) => {
  const granted = (
    Object.keys(driverPermissionsLabels) as DriverPermissionKey[]
  ).filter((key) => driver.driverPermission?.[key]);

  if (granted.length === 0) {
    return <span className="text-gray-400">—</span>;
  }

  return (
    <div className="flex flex-wrap gap-2">
      {granted.map((key) => (
        <Badge key={key} title={driverPermissionsLabels[key]} color="green" />
      ))}
    </div>
  );
};

interface TableActionsProps {
  row: Driver;
  canEdit: boolean;
  onEdit: (driver: Driver) => void;
  onDelete: (id: number) => void | Promise<void>;
}

const TableActions = ({
  row,
  canEdit,
  onEdit,
  onDelete,
}: TableActionsProps) => (
  <Actions
    notShow
    notEdit={!canEdit}
    notDelete={!canEdit}
    row={row}
    edit={onEdit}
    delete={onDelete}
  />
);

export const createTableColumns = ({
  canEdit,
  onEdit,
  onDelete,
}: CreateTableColumnsArgs): ColumnDef<Driver>[] => [
  {
    id: "name",
    header: "الاسم",
    size: 220,
    cell: ({ row }) => <NameCell name={row.original.name} />,
  },
  {
    id: "permissions",
    header: "الصلاحيات",
    cell: ({ row }) => <PermissionsBadges driver={row.original} />,
  },
  {
    id: "actions",
    header: "الخيارات",
    size: 120,
    cell: ({ row }) => (
      <TableActions
        row={row.original}
        canEdit={canEdit}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    ),
  },
];
